import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from "../firebase/firebaseConfig";
import { collection, getDocs, doc, getDoc } from "firebase/firestore";

const Members = () => {
    const [data, setData] = useState([]);
    
    useEffect(() => {
        const fetchFormsData = async () => {
            try {
            const querySnapshot = await getDocs(collection(db, "Members"));
            const documents = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setData(documents);
            } catch (error) {
            console.error("Error fetching data: ", error);
            }
        };
    
        fetchFormsData();
    }, []);
    
  return (
    <div id="content">
        <div className='row'>
        <div className='col-sm-6'>
            <h1>Revival Church Members</h1>
            <h2 className='ev-sub-title'>Montana Campus</h2>
        </div>
        <div className='col-sm-6 calendar-buttons'>
            <div className='event-button'>
                <Link to="/add-a-member"><button>Add a Member</button></Link>
            </div>
        </div>
        </div>
      <br/>
        <div className="row">
          {data.map((item, index) => (
            <div className="col-sm-3 member-box" key={index}>
                <img src={item.ProfileImage} className='group-image'/>
                <h3 className="member-name">{item.Name} {item.Surname}</h3>
                {/* <p className="member-meta-data">
                  {item.Ministry.map((minist, ind) => (
                    <span>{minist} </span>
                  ))}
                </p> */}
              <Link to={`/members/${item.id}`}>View Profile</Link>
            </div>
          ))}
        </div>
    </div>
  );
}

export default Members;
